export default __webpack_public_path__ + "static/media/red-ball-inverted.d7258292.svg";